import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getUserError, getUserStatus } from '../store/slices/userSlice';
import $ from "jquery"
import 'datatables.net'
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import { addSpecies, deleteSpecie, editSpecie, getSpecies } from '../store/featureActions';
import ImageViewer from "react-simple-image-viewer";
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: "30%",
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "0px",
        padding: "0px",
    },
};
Modal.setAppElement('#root');
const AllSpecies = () => {
    const [id, setId] = useState()
    const dispatch = useDispatch()
    const status = useSelector(getUserStatus)
    const error = useSelector(getUserError)
    const [speciesList, setSpeciesList] = useState(null)
    const [detail, setDetail] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalType, setModalType] = useState()
    const [name, setName] = useState()
    const [family, setFamily] = useState()
    const [files, setFiles] = useState([])
    const [modalImages, setmodalImages] = useState(false);
    const [currentImage, setCurrentImage] = useState(0);
    const navigate = useNavigate()
    const openImageViewer = useCallback((images, index) => {
        setCurrentImage(index);
        setmodalImages(images);
    }, []);
    function viewModal(item, type) {
        setIsOpen(true);
        if (type == "detail") {
            setDetail(item)
        } else if (type == "create") {
            setId(item)
        } else if (type == "delete") {
            setId(item)
        } else if (type == "edit") {
            setDetail(item)
            setId(item?._id)
        }
        setModalType(type)
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
        setName()
        setFamily()
        setFiles([])
        setCurrentImage(0);
        setmodalImages(false);
    }

    const specieDelete = async (id) => {
        try {
            let payload = {
                params: id,
                isToast: true
            }
            await dispatch(deleteSpecie(payload)).unwrap()
            setIsOpen(false)
            $('#tableData')
                .DataTable().destroy();
            specieList()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const specieEdit = async () => {
        try {
            var formData = new FormData()
            if (name) {
                formData.append("name", name)
            }
            if (family) {
                formData.append("family", family)
            }
            formData.append("specieImage", files)
            let payload = {
                body: formData,
                params: id,
                isToast: true
            }
            await dispatch(editSpecie(payload)).unwrap()
            setIsOpen(false)
            setName()
            setFamily()
            setFiles([])
            $('#tableData')
                .DataTable().destroy();
            specieList()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const Species = async () => {

        var formData = new FormData()
        formData.append("family", family)
        formData.append("name", name)
        formData.append("specieImage", files)
        let payload = {
            body: formData,
            params: false,
            isToast: true
        }
        try {
            await dispatch(addSpecies(payload)).unwrap()
            setIsOpen(false)
            setName()
            setFamily()
            setFiles([])
            if (speciesList) {
                $('#tableData')
                    .DataTable().destroy();
            }
            specieList()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const specieList = async () => {
        try {
            setSpeciesList(null)
            let payload = {
                params: false,
                isToast: false
            }
            const response = await dispatch(getSpecies(payload)).unwrap()
            setSpeciesList(response?.data?.species)
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    useEffect(() => {
        let mount = true
        if (mount) {
            specieList();
        }
        return () => {
            mount = false
        }
    }, [])
    useEffect(() => {
        if (speciesList) {
            $('#tableData')
                .DataTable({
                    lengthMenu: [10, 25, 50, 100, 200],
                    language: {
                        "emptyTable": "Specie List Not Found"
                    },
                    destroy: true,
                });
        }
    }, [speciesList])
    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Change Password"
            >
                <div className='change-password-modal' id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
                    {modalType == "detail" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Image</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <p onClick={() => openImageViewer(detail?.image, 0)}> <b>Image:</b> {detail?.image.length > 0 ? <><img height="20%" width="20%" style={{ borderRadius: 5 }} src={`${detail?.image[0]}`}></img></> : <>No Image Found</>}</p>
                        </div>
                    </> : modalType == "create" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Add Specie</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Family</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Family" value={family} onChange={(e) => setFamily(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Name</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Name" value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Image</span>
                                </div>
                                <input type="file" className="form-control" aria-label="Image" onChange={(e) => setFiles(e?.target?.files[0])} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={Species}>Create</button>
                        </div>
                    </> : modalType == "edit" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Edit Specie</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Family</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Family" defaultValue={detail?.family} value={family} onChange={(e) => setFamily(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Name</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Name" defaultValue={detail?.name} value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Image</span>
                                </div>
                                <input type="file" className="form-control" aria-label="Image" onChange={(e) => setFiles(e?.target?.files[0])} />
                            </div>
                            <button className="btn btn-primary" type="submit" onClick={specieEdit}>Update</button>
                        </div>
                    </> : modalType == "delete" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Delete Specie Confirmation</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="pass-form-wrap" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                    <div className="login-button mt-2" style={{ width: "40%" }}>
                                        <button type="button" onClick={() => specieDelete(id)} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Delete</button>
                                    </div>
                                    <div className="login-button mt-2" style={{ width: "40%" }} >
                                        <button type="button" onClick={closeModal} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </> : <></>}
                </div>
            </Modal>
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: speciesList ? "3%" : "12%"
            }}>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className=" mt-2 mb-3 d-flex justify-content-end">
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} onClick={() => viewModal(null, "create")} >Add Specie
                            </button>
                        </div>
                    </div>
                </section>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="table-responsive" id="tableready">
                                            <table id="tableData" className="table table-bordered display" style={{ width: '100%', textAlign: "center" }}>
                                                <thead>
                                                    {speciesList ? (<tr>
                                                        <th>S.No</th>
                                                        <th>Name</th>
                                                        <th>Family</th>
                                                        <th>Image</th>
                                                        <th>Catch Logged</th>
                                                        <th>Action</th>
                                                        <th>Points</th>
                                                    </tr>) : (<tr></tr>)}
                                                </thead>
                                                <tbody >
                                                    {speciesList?.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>{item?.name}</td>
                                                            <td>{item?.family}</td>
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10, fontSize: 13, }} onClick={() => viewModal(item, "detail")}  ><i className="fas fa-eye"></i> View</span>
                                                                </span>
                                                            </td>
                                                            <td>{item?.loggedCount}</td>
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item, "edit")}  ><i className="fa fa-solid fa-edit"></i> Edit</span>
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item?._id, "delete")}  ><i className="fas fa-trash-alt"></i> Delete</span>
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => navigate("/specie-points", { state: item })}  ><i className="fa fa-plus-circle"></i> Add</span>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                                {!speciesList ?
                                                    status == "loading" || error ? <tfoot>
                                                        <tr><th>{status == "loading" ? "Loading..." : error ? error : ""}</th></tr>
                                                    </tfoot> : <></> : <></>}

                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {modalImages && (
                    <ImageViewer
                        src={modalImages}
                        currentIndex={currentImage}
                        onClose={closeModal}
                        disableScroll={true}
                        backgroundStyle={{
                            backgroundColor: "rgba(0,0,0,0.9)",
                            zIndex: 3
                        }}
                        closeOnClickOutside={true}
                        showPrevButton={currentImage > 0}
                    />
                )}
            </div >
        </>
    )
}
export default AllSpecies
